import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/networkHandler";
export const tokenConfig = (getState) => {
  const token = getState().auth.accessToken;

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
};

// Fetch Top Board
export const getTopBoard = createAsyncThunk(
  "publisher/top-board",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/publisher-top-board`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Publisher
export const createPublisher = createAsyncThunk(
  "publisher/create",
  async (formData, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.post("/admin/publisher/create", formData, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get All Publishers
export const getAllPublishers = createAsyncThunk(
  "publisher/all",
  async (
    { page, rowsPerPage, name, status },
    { getState, rejectWithValue }
  ) => {
    try {
      const config = tokenConfig(getState);
      let params = `page=${page + 1}&limit=${rowsPerPage}`;
      if (name) {
        params += `&name=${encodeURIComponent(name)}`;
      }
      if (status) {
        params += `&status=${encodeURIComponent(status)}`;
      }
      if (status === false) {
        params += `&status=${encodeURIComponent(status)}`;
      }
      //console.log(params)
      const response = await axios.get(`admin/all-publishers?${params}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Publisher by ID
export const getPublisherById = createAsyncThunk(
  "publisher/getById",
  async (id, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/publisher/${id}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Update Publisher
export const updatePublisher = createAsyncThunk(
  "publisher/update",
  async ({id, formData}, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.put(`/admin/publisher/${id}`, formData, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Publisher Link by id
export const getPublisherLink = createAsyncThunk(
  "publisher/link/getById",
  async (id, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/campaign-publishers-links/${id}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get publisher cpa by id
export const getCpaById = createAsyncThunk(
  "admin/cpa/getById",
  async (id, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/campaign-cpa/${id}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Update publisher cpa
export const updatePublisherCpa = createAsyncThunk(
  "/admin/update-publisher-cpa",
  async ({ id, costPerUser }, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.put(`/admin/publisher-cpa/${id}`, { costPerUser }, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  });

  //Create Postback Settings
export const createPostbackSettings = createAsyncThunk(
  "admin/create-postback-settings",
  async ({id, formData}, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.post(`/admin/publisher-postback-settings?staticId=${id}`, formData, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//Get Postback Settings
export const getPostbackSettings = createAsyncThunk(
  "admin/postback-settings",
  async (id, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/publisher-postback-settings/${id}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
)


const publisherSlice = createSlice({
  name: "publisher",
  initialState: {
    loading: false,
    topBoard: {},
    publishers: [],
    publisher: {},
    publisherLink: [],
    postbackSetting: {
      timeInterval: "0",
      range: "0",
      pbPublisher: "0",
      pbMetaClick: "0",
      staticId: "0"
    },
    meta: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      //get-top-board
      .addCase(getTopBoard.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTopBoard.fulfilled, (state, action) => {
        state.loading = false;
        state.topBoard = action.payload.data;
      })
      .addCase(getTopBoard.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching top board:", action.payload);
      })
      //create-publisher
      .addCase(createPublisher.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPublisher.fulfilled, (state, action) => {
        state.loading = false;
        console.log("Publisher created successfully:", action.payload);
      })
      .addCase(createPublisher.rejected, (state, action) => {
        state.loading = false;
        console.error("Error creating publisher:", action.payload);
      })
      //get-all-publishers
      .addCase(getAllPublishers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPublishers.fulfilled, (state, action) => {
        state.loading = false;
        state.publishers = action.payload.data;
        state.meta = action.payload.meta; // Store pagination meta
      })
      .addCase(getAllPublishers.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching publishers:", action.payload);
      })
      //get-publisher-by-id
      .addCase(getPublisherById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPublisherById.fulfilled, (state, action) => {
        state.loading = false;
        state.publisher = action.payload.data;
      })
      .addCase(getPublisherById.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching publisher by ID:", action.payload);
      })
      //update-publisher
      .addCase(updatePublisher.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePublisher.fulfilled, (state, action) => {
        state.loading = false;
        console.log("Publisher updated successfully:", action.payload);
      })
      .addCase(updatePublisher.rejected, (state, action) => {
        state.loading = false;
        console.error("Error updating publisher:", action.payload);
      })
      //get-publisher-link-by-id
      .addCase(getPublisherLink.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPublisherLink.fulfilled, (state, action) => {
        state.loading = false;
        state.publisherLink = action.payload.data;
      })
      .addCase(getPublisherLink.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching publisher link by ID:", action.payload);
      })
      //get-publisher-cpa-by-id
      .addCase(getCpaById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCpaById.fulfilled, (state, action) => {
        state.loading = false;
        console.log("Publisher CPA fetched successfully:", action.payload);
      })
      .addCase(getCpaById.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching publisher CPA by ID:", action.payload);
      })
      //update-publisher-cpa
      .addCase(updatePublisherCpa.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePublisherCpa.fulfilled, (state, action) => {
        state.loading = false;
        console.log("Publisher CPA updated successfully:", action.payload);
      })
      .addCase(updatePublisherCpa.rejected, (state, action) => {
        state.loading = false;
        console.error("Error updating publisher CPA:", action.payload);
      })
      //create-postback-settings
      .addCase(createPostbackSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPostbackSettings.fulfilled, (state, action) => {
        state.loading = false;
        console.log("Postback settings created successfully:", action.payload);
      })
      .addCase(createPostbackSettings.rejected, (state, action) => {
        state.loading = false;
        console.error("Error creating postback settings:", action.payload);
      })
      //get-postback-settings
      .addCase(getPostbackSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPostbackSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.postbackSetting = action.payload.data;
      })
      .addCase(getPostbackSettings.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching postback settings:", action.payload);
      });
  },
});

export default publisherSlice.reducer;
